import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { operationApi } from "./operationApi";
import { assertSuccessfulResponse, getRequestErrorMessage } from "../../services/apiMessages";
import { buildNameCodeIdLabel } from "../../pages/masters/masterMetadata";

export default function useRelationOperations(plantId, relationType) {
  const dispatch = useDispatch();
  const [state, setState] = useState({ options: [], isLoading: false, error: "" });
  const [attempt, setAttempt] = useState(0);
  const generation = useRef(0);
  useEffect(() => {
    const version = ++generation.current;
    if (!plantId || !relationType) {
      setState({ options: [], isLoading: false, error: "" });
      return;
    }
    setState({ options: [], isLoading: true, error: "" });
    const load = async () => {
      const rows = [];
      for (let page = 1; ; page += 1) {
        const response = await dispatch(operationApi.endpoints.getOperations.initiate({
          plant_id: plantId, relation_type: relationType, page, limit: 1000,
        }, { subscribe: false, forceRefetch: true })).unwrap();
        if (version !== generation.current) return;
        if (response?.message !== "No Record Found") assertSuccessfulResponse(response);
        const batch = response?.data || [];
        rows.push(...batch);
        if (!batch.length || rows.length >= (response?.meta_data?.total_records ?? rows.length)) break;
      }
      setState({
        options: rows.filter((row) => row.plant_id === plantId && row.relation_type?.toUpperCase() === relationType.toUpperCase()).map((row) => ({
          value: row.operation_id,
          label: buildNameCodeIdLabel({ name: row.operation_name, code: row.operation_code, id: row.operation_id }),
        })),
        isLoading: false, error: "",
      });
    };
    load().catch((error) => {
      if (version === generation.current) setState({ options: [], isLoading: false, error: getRequestErrorMessage(error, "Unable to load operations.") });
    });
    return () => { generation.current += 1; };
  }, [dispatch, plantId, relationType, attempt]);
  return { ...state, retry: () => setAttempt((current) => current + 1) };
}
